// React bootstrap table next =>
// DOCS: https://react-bootstrap-table.github.io/react-bootstrap-table2/docs/
// STORYBOOK: https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html
import React, { useEffect, useMemo, useRef, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {PaginationProvider,  } from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../_redux/pharma-deliveries/pharmaDeliveriesActions";
import * as pharmaCrud from "../../../_redux/pharma/pharmaCrud";
import * as ordersCrud from "../../../../Sales/_redux/orders/ordersCrud";
import ReactToPrint, { useReactToPrint } from "react-to-print";

import {
  getSelectRow,
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
} from "../../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { usePharmaDeliveriesUIContext } from "../PharmaDeliveriesUIContext";
import * as uiHelpers from "../PharmaDeliveriesUIHelpers";
import { Badge, Button, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { OrderPrintPage } from "../OrderPrintPage";
import { CancelOrderDialog } from "../../../../Sales/pages/orders/order-edit/CancelOrderDialog";
import Swal from "sweetalert2";
import { errorMsg, successMsg } from "../../../../Global/helpers";
import { esPedidoMiTest, reenviarMailRetiroFarmacia } from "../../../mailRetiroFarmacia";

// const capitalizeWords = (name)=>{
//   const words = name.toLowerCase().split(" ");

//   return words.map((word) => { 
//       return word[0].toUpperCase() + word.substring(1); 
//   }).join(" ");  
// }

const capitalizeWords = (name) => {
  if (!name || typeof name !== "string") return "";

  return name
    .trim()                  
    .toLowerCase()
    .split(/\s+/)            
    .filter(Boolean)         
    .map(word => 
      word.charAt(0).toUpperCase() + word.slice(1)
    )
    .join(" ");
};


export function PharmaDeliveriesTable({setOrderDeliveryOk}) {

  const printOrderRef = useRef();
  const [orderToPrint, setOrderToPrint] = useState(null);
  const [orderToCancel, setOrderToCancel] = useState(null);
  const [showCancelOrderConfirmation, setShowCancelOrderConfirmation] = useState(false);
    
  const pharmaDeliveriesUIContext = usePharmaDeliveriesUIContext();
  const pharmaDeliveriesUIProps = useMemo(() => {
    return {
      queryParams: pharmaDeliveriesUIContext.ordersQueryParams,
      setQueryParams: pharmaDeliveriesUIContext.setOrdersQueryParams,
      openEditOrderPage: pharmaDeliveriesUIContext.openEditOrderPage,
      selectedIds: pharmaDeliveriesUIContext.selectedIds,
      setSelectedIds: pharmaDeliveriesUIContext.setSelectedIds
    };
  }, [pharmaDeliveriesUIContext]);

  // Getting curret state of orders list from store (Redux)
  const { reportState } = useSelector(
    (state) => ({ reportState: state.pharmaDeliveries }),
    shallowEqual
  );
  const { totalCount, entities, listLoading, ordersUpdated:reportUpdated } = reportState;

  const { orderState } = useSelector(
    (state) => ({ orderState: state.orders }),
    shallowEqual
  );
  const { ordersUpdated:orderUpdated } = orderState;


  // orders Redux state
  const dispatch = useDispatch();

  const deliver=(order)=>{
      setOrderDeliveryOk(order)
  }
  
  const cancel=(order)=>{
    setShowCancelOrderConfirmation(true);
    setOrderToCancel(order);
    
  }

  const cancelReceived= async(order)=>{
      Swal.fire({
          title: 'Confirmación',
          text: `Cancela la recepción en farmacia de la órden ${order.id}?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sí',
          confirmButtonColor: '#0A9E95',
          cancelButtonText:'No'
      }).then(async res=>{
          if (res.isConfirmed) {
              try{
                  await pharmaCrud.unsetOrderReceived(order)
                  dispatch(actions.fetchOrders(pharmaDeliveriesUIProps.queryParams));
                  successMsg(`Se canceló la recepción en farmacia de la órden ${order.id}`);

              }
              catch(err){
                  errorMsg("Error cancelando recepción")
              }
          } 
      })    
  }

  // Reenvio del aviso al cliente de que ya puede retirar el pedido (solo Mi Test)
  const reenviarAvisoRetiro = async (order)=>{
      await reenviarMailRetiroFarmacia(order.id);
      dispatch(actions.fetchOrders(pharmaDeliveriesUIProps.queryParams));
  }

  const returnToJBJ = async (row)=>{
      Swal.fire({
          title: 'Confirmación',
          text: `Confirma la devolución a JBJ de la órden ${row.id}?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sí',
          confirmButtonColor: '#0A9E95',
          cancelButtonText:'No'
      }).then(async res=>{
          if (res.isConfirmed) {
            try{
                  await ordersCrud.returnToJBJ(row.id);
                  successMsg(`La orden se devolvió correctamente`);
                  dispatch(actions.fetchOrders(pharmaDeliveriesUIProps.queryParams));
            }
            catch(err){
                console.log(err)
                errorMsg("Error no se pudo devolver")
            }
        }
      })
  }

  const handlePrint = useReactToPrint({
    content: () => printOrderRef.current,
  });

  const printGuide=(order)=>{
      //dispatch(printActions.printGuideFromPharmacy(order.id))  
      ordersCrud.getOrderById(order.id).then(response=>{
        setOrderToPrint(response.data.results)
        handlePrint();
      }) 
  }

  // useEffect(() => {
    
  //   dispatch(actions.fetchOrders(pharmaDeliveriesUIProps.queryParams));
  // }, [ pharmaDeliveriesUIProps.queryParams, reportUpdated, orderUpdated]);

  useEffect(() => {
    const controller = new AbortController();

    dispatch(actions.fetchOrders(
      pharmaDeliveriesUIProps.queryParams,
      controller.signal
    ));

    return () => {
      controller.abort(); // se cancela cuando cambian deps o unmount
    };
  }, [pharmaDeliveriesUIProps.queryParams, reportUpdated, orderUpdated]);

  // Table columns
  const columns = [
    {
      dataField: "id",
      text: "ID",
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.IdColumnFormatter,
      formatExtraData: {
        openEditOrderPage: pharmaDeliveriesUIProps.openEditOrderPage
      },
    },
    {
      dataField: "customer",
      text: "Cliente",
      //filter: textFilter(),
      sort: true,
      sortCaret: sortCaret,
      formatter: (cellContent, row) => (
        <span style={{  }}>
          <p style={{ marginBottom:'0' }}>{ capitalizeWords(cellContent.first_name) }</p>
          <p style={{ marginBottom:'0' }}>{ capitalizeWords(cellContent.last_name) }</p>
          { (row.billing.last_name?.toLowerCase().trim()!=cellContent.last_name?.toLowerCase().trim() && row.billing.first_name?.toLowerCase().trim()!=cellContent.first_name?.toLowerCase().trim())? 
            <p style={{ marginBottom:'0' }}>
              (Fc: { capitalizeWords(row.billing?.first_name) } { capitalizeWords(row.billing?.last_name) })
            </p>: ""
          }
        </span>
      )
    },
    // {
    //   dataField: "billing",
    //   text: "Facturado a",
    //   //filter: textFilter(),
    //   sort: true,
    //   sortCaret: sortCaret,
    //   formatter: (cellContent, row) => (
    //     <span style={{  }}>
    //       <p style={{ marginBottom:'0' }}>{ capitalizeWords(cellContent.last_name) }</p>
    //       <p style={{ marginBottom:'0' }}>{ capitalizeWords(cellContent.first_name) }</p>
    //     </span>
    //   )
    // },
    {
      dataField: "billing.tax.number",
      text: "Documento",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "source.name",
      text: "Origen",
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.SourceColumnFormatter
    },

    {
      dataField: "order_creation",
      text: "Fecha",
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.DateColumnFormatter
    },
    {
      dataField: "shipping.type.name",
      text: "Envío",
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.ShippingTypeColumnFormatter
    },
    {
      dataField: "paid_date",
      text: "",
      sort: false,
      formatter: (cell)=>{
        return (<> { cell && 
            <OverlayTrigger overlay={<Tooltip id="orders-delete-tooltip">Pagada</Tooltip>} >
              <span><i className={"text-success fa fa-dollar-sign"}></i> </span> 
            </OverlayTrigger>            
          } </> )
      },
      headerFormatter: ()=> {
            return (
                <OverlayTrigger 
                  placement="top" 
                  overlay={<Tooltip id="header-delivered-tooltip">Pagada</Tooltip>}
                >
                <span><i className={"fa fa-credit-card"}></i> </span>
                </OverlayTrigger>
            )
      }
    },
    {
      dataField: "shipping.note",
      text: "",
      sort: false,
      //isDummyField: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.NotesColumnFormatter,
      headerFormatter: ()=> {
            return (
                <OverlayTrigger 
                  placement="top" 
                  overlay={<Tooltip id="header-delivered-tooltip">Observaciones</Tooltip>}
                >               
                <span><i className={"far fa-comment"}></i> </span>
                </OverlayTrigger>
            )
        }
    },
    {
      dataField: "ready_to_pickup",
      text: "",
      sort: false,
      formatter: (cellContent)=>{
        return (<> { Boolean(cellContent) && 
          <OverlayTrigger overlay={<Tooltip id="orders-delete-tooltip">Recibida</Tooltip>} >
            <span><i className={"text-success fa fa-check"}></i> </span> 
          </OverlayTrigger>            
        } </> )

      },
      headerFormatter: ()=> {
            return (
                <OverlayTrigger 
                  placement="top" 
                  overlay={<Tooltip id="header-delivered-tooltip">Recibida</Tooltip>}
                >
                  <span><i className={"fas fa-box-open"}></i> </span>
                </OverlayTrigger>              
            )
        }
    },
    {
      dataField: "delivered_date",
      text: "",
      sort: false,
      formatter: (cellContent)=>{
        return (<> { cellContent && 
          <OverlayTrigger overlay={<Tooltip id="orders-delete-tooltip">Entregada</Tooltip>} >
            <span><i className={"text-success fa fa-check"}></i> </span> 
          </OverlayTrigger>            
        } </> )

      },
      headerFormatter: () => {
        return (
          <OverlayTrigger 
            placement="top" 
            overlay={<Tooltip id="header-delivered-tooltip">Entregada</Tooltip>}
          >
            <span><i className="far fa-handshake"></i></span>
          </OverlayTrigger>
        );
      }
    },
    {
      // Aviso al cliente de que ya puede retirar el pedido (solo unidad de negocio Mi Test)
      dataField: "mail_retiro_farmacia_enviado",
      text: "",
      sort: false,
      formatter: (cellContent, row)=>{
        if (!esPedidoMiTest(row) || !row.ready_to_pickup) {
          return <></>
        }
        return (<> { cellContent ?
          <OverlayTrigger overlay={<Tooltip id="mail-retiro-tooltip">Aviso al cliente enviado</Tooltip>} >
            <span><i className={"text-success fa fa-envelope"}></i> </span>
          </OverlayTrigger>
          :
          <OverlayTrigger overlay={<Tooltip id="mail-retiro-tooltip">No se le avisó al cliente</Tooltip>} >
            <span><i className={"text-danger fa fa-envelope"}></i> </span>
          </OverlayTrigger>
        } </> )

      },
      headerFormatter: ()=> {
            return (
                <OverlayTrigger 
                  placement="top" 
                  overlay={<Tooltip id="header-mail-retiro-tooltip">Aviso al cliente (Mi Test)</Tooltip>}
                >
                  <span><i className={"far fa-envelope"}></i> </span>
                </OverlayTrigger>              
            )
        }
    },
    {
      dataField: "entregar",
      text: "",
      dummyField: true,
      headerClasses: "text-center",
      classes: "text-center",
      formatter: (cell, row)=>{
        
        return (
          <>
         {!row.delivered_date &&
            <>
                  <OverlayTrigger overlay={<Tooltip id="waves-print-tooltip">Imprimir Orden</Tooltip>} >
                    <a className="btn btn-icon btn-light btn-hover-primary btn-sm mx-1" onClick={() => {printGuide(row)}} > <span><i className="fa fa-print text-info"></i></span> </a>
                  </OverlayTrigger>

              {/* <ComponentToPrintWrapper row={row} ></ComponentToPrintWrapper> */}
 
                <OverlayTrigger overlay={<Tooltip id="waves-print-tooltip">Entregar</Tooltip>} >
                  <a className="btn btn-icon btn-light btn-hover-primary btn-sm mx-1" onClick={() => {deliver(row)}} > <span><i className="fa fa-clipboard-check text-primary"></i></span> </a>
                </OverlayTrigger>
                {/* { Boolean( row.business_unit?.id != 3 ) && //por ahora excluímos mitest
                  <OverlayTrigger overlay={<Tooltip id="waves-print-tooltip">Cancelar Orden</Tooltip>} >
                    <a className="btn btn-icon btn-light btn-hover-danger btn-sm mx-1" onClick={() => {cancel(row)}} > <span><i className="fa fa-trash text-danger"></i></span> </a>
                  </OverlayTrigger>
                } */}
                { Boolean( row.ready_to_pickup ) && //por ahora excluímos mitest
                  <>
                    <OverlayTrigger overlay={<Tooltip id="waves-print-tooltip">Quitar marca de recibido</Tooltip>} >
                      <a className="btn btn-icon btn-light btn-hover-danger btn-sm mx-1" onClick={() => {cancelReceived(row)}} > 
                        <span><i className="fas fa-undo text-warning"></i></span> </a>
                    </OverlayTrigger>
                    <OverlayTrigger overlay={<Tooltip id="waves-print-tooltip">Devolver pedido a JBJ</Tooltip>} >
                      <a className="btn btn-icon btn-light btn-hover-danger btn-sm mx-1" onClick={() => {returnToJBJ(row)}} >
                        <span><i className="fas fa-handshake-slash text-danger"></i></span> </a>
                    </OverlayTrigger>
                    { Boolean( esPedidoMiTest(row) && !row.mail_retiro_farmacia_enviado ) && //el aviso al cliente es solo de mitest
                      <OverlayTrigger overlay={<Tooltip id="waves-print-tooltip">Reenviar aviso al cliente</Tooltip>} >
                        <a className="btn btn-icon btn-light btn-hover-primary btn-sm mx-1" onClick={() => {reenviarAvisoRetiro(row)}} >
                          <span><i className="fas fa-envelope text-primary"></i></span> </a>
                      </OverlayTrigger>
                    }
                  </>
                }
            </>

          }
          
          </>
      )
      },
    },

  ];
  

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: pharmaDeliveriesUIProps.queryParams.pageSize,
    page: pharmaDeliveriesUIProps.queryParams.pageNumber,
    paginationTotalRenderer: (from, to, size) => (
      <span className="react-bootstrap-table-pagination-total">
        Mostrando { from } a { to } de { size } Resultados
      </span>
    )
  };
  
  // const selectRow = {
  //   mode: 'checkbox',
  //   clickToSelect: false,
  //   selectColumnPosition: 'left',
  //   hideSelectAll: true,
  //   bgColor: '#C9F7F5',
  //   selected:pharmaDeliveriesUIProps.selectedIds,
  //   onSelect: (row, isSelect, rowIndex, e) => {
  //       if (true) {
  //           if(isSelect){
  //             pharmaDeliveriesUIProps.setSelectedIds([...pharmaDeliveriesUIProps.selectedIds, row.id]);
  //           }
  //           else{
  //             pharmaDeliveriesUIProps.setSelectedIds(pharmaDeliveriesUIProps.selectedIds.filter(item=>item!=row.id))
  //           }
  //       }
  //     },
  // };



  return (
    <>

      {orderToPrint && <OrderPrintPage ref={printOrderRef} order={orderToPrint}/>}

      <CancelOrderDialog show={showCancelOrderConfirmation} onHide={()=>setShowCancelOrderConfirmation(false)} order={orderToCancel}/>

      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (

            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
            >

              <BootstrapTable
                rowStyle={ { fontSize: "smaller" } }
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                bordered={false}
                condensed={false}
                // striped={true}
                remote //</Pagination>= { { filter: true } }
                //filter={ filterFactory() }
                keyField="id"
                data={entities === null ? [] : entities}
                columns={columns}
                defaultSorted={uiHelpers.defaultSorted}
                // selectRow={ selectRow } 
                onTableChange={ getHandlerTableChange( pharmaDeliveriesUIProps.setQueryParams) }
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={entities} />
                <NoRecordsFoundMessage entities={entities} />
              </BootstrapTable>

            </Pagination>

          );
        }}
      </PaginationProvider>
    </>
  );
}
